import { render, staticRenderFns } from "./TicketSurvey.vue?vue&type=template&id=f203a83a&scoped=true"
import script from "./TicketSurvey.vue?vue&type=script&lang=js"
export * from "./TicketSurvey.vue?vue&type=script&lang=js"
import style0 from "./TicketSurvey.vue?vue&type=style&index=0&id=f203a83a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f203a83a",
  null
  
)

export default component.exports